<!-- AltaMesaCultivo.vue -->

<template>
    <div>
      <h2>Alta de Mesa de Cultivo</h2>
  
      <!-- Formulario de alta -->
      <form @submit.prevent="submitForm" class="mb-4">
        <div class="mb-3">
          <label for="nombre" class="form-label">Nombre:</label>
          <input v-model="mesa.nombre" type="text" class="form-control" id="nombre" required>
        </div>
  
        <div class="mb-3">
          <label for="largo" class="form-label">Largo (metros):</label>
          <input v-model="mesa.largo" type="number" step="0.01" class="form-control" id="largo" required>
        </div>
  
        <div class="mb-3">
          <label for="ancho" class="form-label">Ancho (metros):</label>
          <input v-model="mesa.ancho" type="number" step="0.01" class="form-control" id="ancho" required>
        </div>
  
        <div class="mb-3">
          <label for="descripcion" class="form-label">Descripción:</label>
          <textarea v-model="mesa.descripcion" class="form-control" id="descripcion"></textarea>
        </div>
  
        <!-- Otros campos relacionados con la mesa de cultivo -->
  
        <button type="submit" class="btn btn-primary">Guardar</button>
        <button @click="$router.go(-1)" class="btn btn-outline-secondary">Cancelar</button>
      </form>
    </div>
  </template>
  
  <script>
  import axios from '@/axios';
  
  export default {
    props: {
      club_id: {
        type: Number,
        required: true,
      },
      salaDeCultivoId: {
        type: Number,
        required: true,
      },
    },
    data() {
      return {
        mesa: {
          nombre: '',
          largo: null,
          ancho: null,
          descripcion: '',
        },
        clubActual:this.$store.getters.getClubActual,
      };
    },
    
    methods: {
      async submitForm() {
        try {

          // Asignar el id de la sala de cultivo a la que pertenece la mesa
          this.mesa.salaDeCultivoId = this.$props.salaDeCultivoId;
          // Llamar a la API para crear la mesa de cultivo

          const response= await axios.post('/api/mesaDeCultivo', {form:this.mesa, club_id: this.clubActual.id});
  
         if(response.status === 200)
         {
              alert('Mesa de cultivo creada con éxito');
              this.$router.go(-1);
         }
          
        } catch (error) {
          console.error('Error al crear la mesa de cultivo:', error);
        }
      },
    },
  };
  </script>
  
  <style scoped>
  /* Estilos específicos para este componente si es necesario */
  </style>
  